import React from 'react';

export interface IProps {
  value: string;
  name?: string;
  isReadonly?: boolean;
  data: any[];
  displayField: string;
  valueField: string;
  onChange?: (event: any) => void;
  showAddModalLabel?: boolean;
  addModalLabelText?: string;
  onAddModalLabelClick?: () => any;
  onModalSave?: any;
  style?: any;
}

export const DropdownControl = (props: IProps) => {
  const style = {
    backgroundColor: '#28333c',
    borderColor: 'transparent',
    color: props.isReadonly ? 'grey' : 'white',
    height: 28,
    minWidth: '120px',
    paddingLeft: 6,
    width: '25vw',
    marginLeft: '-3px',
    ...props.style,
  };

  let selected: number = 0;
  if (props.isReadonly) {
    props.data.every((item, index) => {
      if (item[props.valueField] !== null && props.value !== null) {
        if (item[props.valueField].toString().trim() === props.value.toString()) {
          selected = index;
          return false;
        }
      }
      return true;
    });
  }
  return (
    <React.Fragment>
      <table>
        <tbody>
          <tr>
            <td>
              {!props.isReadonly ? (
                <select
                  style={style}
                  value={props.value ? props.value.toString().trim() : ''}
                  name={props.name}
                  disabled={props.isReadonly}
                  onChange={props.onChange}
                >
                  {props.data.map((x: any) => (
                    <option value={x[props.valueField].toString().trim()} key={x[props.valueField]}>
                      {x[props.displayField]}
                    </option>
                  ))}
                </select>
              ) : (
                <span style={{ paddingLeft: 6 }}>{props.data[selected][props.displayField]}</span>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default DropdownControl;
